import { Button } from "@mui/material"
import { useEffect } from "react"
import { useLocation } from "react-router-dom"

export default function Bloqueio() {
	const { state } = useLocation()


	useEffect(() => {
		// ~
		console.log(state)
	}, [state])

	return <div style={{ height: "calc(var(--app-vh) - 2rem)", marginTop: "-2rem" }}>
		<div className="pt-3">
			<div style={{
				background: "#d46060",
				padding: "20px",
				borderRadius: "10px",
				margin: "24px",
			}}>
				<p style={{ color: "white", textAlign: "center" }}>{state.msg}</p>
				<Button fullWidth variant="contained" color="error" onClick={() => {
					window.AndroidInterface?.redirectLink(state.link)
				}}>
					Atualizar
				</Button>
			</div>
		</div>
	</div>
}